var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-textarea',{staticClass:"appup-textarea",attrs:{"id":_vm.id,"state":_vm.state,"placeholder":_vm.placeholder,"rows":3,"max-rows":6},on:{"input":_vm.onChange},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/inputs/textarea/textarea.vue